
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scheduleDiscount/create",
      function () {
        return require("private-next-pages/scheduleDiscount/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scheduleDiscount/create"])
      });
    }
  